const AfterTable = () => {
    return (
        <div className="row mb-3 mt-2">
            <div className="col-12">
                <span className="text">¿Quieres incorporar una cadena que no está en la lista?. Envía un correo a
                    <b> felipe.salazar@teamcore.cl</b> con la información.
                </span>
                <br />
            </div>
        </div>
    );
};

export default AfterTable;
